import React, { useState } from 'react';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Folder } from '../../../../../../constants/APIs';
import {
    Input,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert
} from 'reactstrap';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

export default function EditFolderForm({
    visible,
    toggleModal,
    formLabel,
    propertyId,
    status,
    selectedFolder,
    folderName,
    folderId,
    setFolderName,
    updateFolderName
}) {
    const [apiState, setApiState] = useState('default');
    const [errorMessage, setErrorMessage] = useState('');
    console.log(11, folderId)
    const handleSubmit = () => {
        if (!folderName || !folderId) {
            setErrorMessage('Folder name is required.');
            return;
        }

        const body = {
            groupId: getGroupID(),
            propertyId: propertyId,
            creator: 'dashboard',
            folderName: folderName,
            status: 'Active',
            folderPath: selectedFolder,
        };

        setApiState('processing');
        setErrorMessage('');

        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Folder}/${folderId}`,
            data: body,
        })
            .then(res => {
                if (res?.data?.status === "Name already exist") {
                    setApiState('fail');
                    NotificationManager.error(
                        "Folder name already exists. Please choose a different name.",
                        "Error",
                        3000
                    );
                    return;
                } else {
                    setApiState('success');
                    NotificationManager.success(
                        "Folder updated successfully",
                        "Success",
                        3000
                    );
                    toggleModal();
                    updateFolderName({ id: folderId, name: folderName });
                }
            })
            .catch(error => {
                setApiState('fail');
                setErrorMessage('Failed to update folder. Please try again.');
                console.error('Error updating folder:', error);
            });
    };


    return (
        <Modal isOpen={visible} toggle={toggleModal}>
            <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
            <ModalBody>
                {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                <Input
                    type="text"
                    value={folderName}
                    onChange={(e) => setFolderName(e.target.value)}
                    placeholder="Folder name"
                />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSubmit}>Save</Button>
                <Button color="secondary" onClick={toggleModal}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}
